import { Component, Inject, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { SaleTeamMappingEmployeeInfo } from '../model/SaleTeamMappingEmployeeInfo.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GlobalService } from '../service/global.service';
import { ActivatedRoute } from '@angular/router';
import { TokenService } from '../service/token.service';
import { environment } from 'src/environments/environment';
import { ProjectSaleInfo } from '../model/projectsale.model';
import { ProjectSaleReportInfo } from '../model/ProjectSaleReportInfo.model';
//import { ChartOptions, ChartType } from 'chart.js';
//import { ChartDataSets } from 'chart.js';
import { BaseChartDirective, Label } from 'ng2-charts';

@Component({
  selector: 'app-projectsalereport',
  templateUrl: './projectsalereport.component.html',
  styleUrls: ['./projectsalereport.component.css']
})
export class ProjectsalereportComponent implements OnInit {
  _ForK2: string;
  _EmpCode: string;
  _ParamEmpCode: string;

  baseurl: string;

  yearOptions: ProjectSaleInfo[] = [];
  quarterOptions: string[] = [];
  monthOptions: { value: string; label: string }[] = [];
  SaleTargetYearList: string[] = [];

  // Search variables
  periodSearch: string = 'YEAR';
  yearSearch: string = null;
  noYearBack: number = 5;
  quarterSearch: string = null;
  monthSearch: string = null;
  txtSearchSaleTeam: string = null;

  SaleTeamList: SaleTeamMappingEmployeeInfo[] = [];
  SaleTeamUnderList: SaleTeamMappingEmployeeInfo[] = [];

  // Main Data
  SaleTeamTargetList: ProjectSaleReportInfo[] = [];
  SaleTeamActualList: ProjectSaleReportInfo[] = [];

  modalPeriodSelected = "YEAR";
  yearValidationError: boolean = false;

  ddlMonthStart: string = null;
  ddlMonthEnd: string = null;
  isMonthEndValid: boolean = true;
  yearErrorMessage: string = '';
  monthErrorMessage: string = '';

  MonthList = [
    { MonthCode: '1', MonthName: 'Jan' },
    { MonthCode: '2', MonthName: 'Feb' },
    { MonthCode: '3', MonthName: 'Mar' },
    { MonthCode: '4', MonthName: 'Apr' },
    { MonthCode: '5', MonthName: 'May' },
    { MonthCode: '6', MonthName: 'Jun' },
    { MonthCode: '7', MonthName: 'Jul' },
    { MonthCode: '8', MonthName: 'Aug' },
    { MonthCode: '9', MonthName: 'Sep' },
    { MonthCode: '10', MonthName: 'Oct' },
    { MonthCode: '11', MonthName: 'Nov' },
    { MonthCode: '12', MonthName: 'Dec' },
  ];

  // Zone pagination variable
  public indexNo: number = 0;
  public currentPageNumber: number = 0;
  public totalPages: number = 0;
  public totalItems: number = 0;
  public environment: number = 999999;

  SaleTargetAllTeamLast: number = 0; // For Use in chart line Target All Team

  chartPerTeam: {
  teamCode: string;
  teamName: string;
  labels: string[];
  datasets: any[
  ];
  }[] = [];

  // Block chart เก่า //
  barChartOptions: any = {
  responsive: true,
  scales: {
    xAxes: [{
      id: 'x-axis-bar',
      offset: true, // เก็บ offset: true สำหรับ bar chart
      ticks: {
        beginAtZero: true
      }
    }, {
      id: 'x-axis-line', 
      offset: false, // offset: false สำหรับ line chart
      display: false, // ซ่อน axis นี้
      ticks: {
        beginAtZero: true
      }
    }],
    yAxes: [{
      ticks: {
        beginAtZero: true,
        callback: function(value) {
          return value.toLocaleString();
        }
      }
    }]
  },
  tooltips: {
    callbacks: {
      label: function(tooltipItem, data) {
        const label = data.datasets[tooltipItem.datasetIndex].label || '';
        const value = tooltipItem.yLabel;
        return `${label}: ${Number(value).toLocaleString()}`;
      }
    }
  },
  plugins: {
    datalabels: {
      anchor: 'end',
      align: 'top',
      color: '#000',
      font: {
        weight: 'bold'
      },
      formatter: function(value: any) {
        const numericValue = Number(value);
        if (numericValue >= 0) {
          if (numericValue >= 1000000) {
            return (numericValue / 1000000).toFixed(2) + 'M';
          }
          return numericValue.toLocaleString();
        } else {
          return null;
        }
      }
    }
  }
};

  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, 
              private formBuilder: FormBuilder, private GlobalService: GlobalService, 
              private activatedRoute: ActivatedRoute, private TokenService: TokenService) { 

                this.baseurl = environment.base_api;
                this._ForK2 = this.activatedRoute.snapshot.params.ForK2;
                this._ParamEmpCode = this.activatedRoute.snapshot.params.EmpCode;
                GlobalService.CheckPagingAccessRights();
              }

  async ngOnInit(): Promise<void> {
    this._EmpCode = !!this._ParamEmpCode ? this._ParamEmpCode : localStorage.getItem("EmpCode");
      if (!!this._ForK2) {
        localStorage.setItem("EmpCode", this._ParamEmpCode);
      }

      await this.initializeComponent();
      await this.loadTeamTarget();
      await this.loadTeamActual();
      this.generateChartDataPerTeam();
      //this.loadMockGroupedCharts();
  }

  async initializeComponent() {
    await this.loadInitialData();
  }

  async loadInitialData() {
    await this.loadLeadYears();
    await this.loadQuarterOptions();
    await this.loadMonthOptions();
    await this.loadSaleTeams();
  }

  async loadLeadYears() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      try {
        const result = await this.httpClient.get<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/GetLeadYears", httpOptions).toPromise();
        if (result && result.length > 0) {
          this.yearOptions = result;
          if (this.yearOptions.length >= 2) {
            this.yearSearch = this.yearOptions[this.yearOptions.length - 2].ProjectSaleYear;
          } else {
            this.yearSearch = this.yearOptions[0].ProjectSaleYear;
          }
          await this.onSelectYearChange();
          //console.log('Default year set to:', this.yearSearch);
        } else {          
          this.yearSearch = null;
          console.error('No years returned from GetLeadYears');
        }
      } catch (error) {
        console.error('Error loading years:', error);
      }
    }
  }

  async loadQuarterOptions() {
    this.quarterOptions = ['Q1', 'Q2', 'Q3', 'Q4'];
  }

  async loadMonthOptions() {
    const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    this.monthOptions = monthNames.map((name, index) => ({
      value: (index + 1).toString(),
      label: name
    }));
  }

  async loadSaleTeams() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${auth_token}`
            })
        };

        var objectjson = {};
        objectjson['EmployeeCode'] = this._EmpCode;
        let strjson = JSON.stringify(objectjson);

        try {
            const data = await this.httpClient.post<SaleTeamMappingEmployeeInfo[]>(this.baseurl + "Team/GetEmpMappingTeam", strjson, httpOptions).toPromise();
            
            this.SaleTeamList = data;
            //console.log('loadSaleTeams: ข้อมูลทีมขายที่ได้รับ:', this.SaleTeamList);
            //console.log('loadSaleTeams: ตั้งค่า txtSearchSaleTeam เป็น:', this.txtSearchSaleTeam);

        } catch (error) {
            console.error('loadSaleTeams: Error โหลดทีมขาย:', error);
            this.SaleTeamList = [];
            this.txtSearchSaleTeam = null; 
        }
    } else {
        console.error('loadSaleTeams: Token ไม่พร้อมใช้งาน');
        this.SaleTeamList = [];
        this.txtSearchSaleTeam = null;
    }
}

  async loadTeamTarget() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${auth_token}`
            })
        };

        const startYear = parseInt(this.yearSearch ?? new Date().getFullYear().toString());
        const yearList = Array.from({ length: this.noYearBack }, (_, i) => (startYear - i).toString());

        const objectjson = {
        SaleTargetYearList: yearList, // string[]
        SaleTargetTeamCode: this.txtSearchSaleTeam, // string | null
        SaleTargetEmpCode: this._EmpCode,
        RequesterEmpCode: this._EmpCode,
        MonthStart: this.ddlMonthStart,
        MonthEnd: this.ddlMonthEnd  
      };

        console.log('loadTeamTarget: objectjson ที่จะส่ง:', objectjson);

        let strjson = JSON.stringify(objectjson);

        try {
            // *** แก้ไข 3: ใช้ await ตรงๆ กับ toPromise() ***
            const data = await this.httpClient.post<ProjectSaleReportInfo[]>(this.baseurl + "ProjectSaleReport/GetTeamTargetReportTeamPerformance", strjson, httpOptions).toPromise();
            this.SaleTeamTargetList = data;

            console.log('loadTeamTarget Group by Team & Year!!:', this.SaleTeamTargetList);
        } catch (error) {
            console.error('loadTeamTarget: Error โหลดเป้าหมายทีม:', error);
            this.SaleTeamTargetList = []; // ตั้งค่าเป็น array ว่างเปล่าเมื่อเกิดข้อผิดพลาด
        }
    } else {
        console.error('loadTeamTarget: Token ไม่พร้อมใช้งาน');
    }
  }

  async onSaleTeamChange(): Promise<void> {
    //await this.loadTeamTarget(); 
    //await this.loadTeamActual();
    //this.generateChartDataPerTeam();
  }

  async onNoYearChange(): Promise<void> {
  // ตรวจสอบค่าที่เลือกจาก noYearBack แล้วสร้างปีย้อนหลัง
  const currentYear = parseInt(this.yearSearch); // ใช้ปีที่เลือกใน dropdown หลัก
  const backCount = this.noYearBack || 1;

  this.SaleTargetYearList = []; // เคลียร์ก่อน
  for (let i = 0; i < backCount; i++) {
    this.SaleTargetYearList.push((currentYear - i).toString());
  }

  //console.log("🔁 ปีที่ส่ง:", this.SaleTargetYearList);

  // เรียกโหลดข้อมูลใหม่ตามปีที่เปลี่ยน
  //await this.loadTeamTarget();
  //await this.loadTeamActual();
  //this.generateChartDataPerTeam()
  }

  async loadTeamActual() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${auth_token}`
            })
        };

        const startYear = parseInt(this.yearSearch ?? new Date().getFullYear().toString());
        const yearList = Array.from({ length: this.noYearBack }, (_, i) => (startYear - i).toString());

        const objectjson = {
        SaleTargetYearList: yearList, // string[]
        SaleTargetTeamCode: this.txtSearchSaleTeam, // string | null
        SaleTargetEmpCode: this._EmpCode,
        AllUnderEmpCode: this._EmpCode,
        MonthStart: this.ddlMonthStart,
        MonthEnd: this.ddlMonthEnd
      };

        //console.log('loadTeamTarget: objectjson ที่จะส่ง:', objectjson);

        let strjson = JSON.stringify(objectjson);

        try {
            // *** แก้ไข 3: ใช้ await ตรงๆ กับ toPromise() ***
            const data = await this.httpClient.post<ProjectSaleReportInfo[]>(this.baseurl + "ProjectSaleReport/GetTeamActualReportTeamPerformance", strjson, httpOptions).toPromise();
            this.SaleTeamActualList = data;

            //console.log('loadTeamActual Group by Team & Year:', this.SaleTeamActualList);
        } catch (error) {
            console.error('loadTeamActual: Error โหลดยอดรายได้ทีม:', error);
            this.SaleTeamActualList = []; // ตั้งค่าเป็น array ว่างเปล่าเมื่อเกิดข้อผิดพลาด
        }
    } else {
        console.error('loadTeamActual: Token ไม่พร้อมใช้งาน');
    }
  }

  async onSelectYearChange(): Promise<void> {
  if (!this.yearSearch) {
    this.yearValidationError = true;
    return;
  }
  
  this.yearValidationError = false;

  const selectedYear = parseInt(this.yearSearch); // เช่น "2025" -> 2025
  const backCount = this.noYearBack || 1;

  // เคลียร์และสร้างรายการปีย้อนหลัง เช่น ['2025', '2024', ...]
  this.SaleTargetYearList = [];
  for (let i = 0; i < backCount; i++) {
    this.SaleTargetYearList.push((selectedYear - i).toString());
  }

  //console.log("เลือกปีหลัก:", this.yearSearch);
  //console.log("ปีที่ใช้ในการ filter:", this.SaleTargetYearList);

  //await this.loadTeamTarget();
  //await this.loadTeamActual();
  //this.generateChartDataPerTeam();
  }

  loadMockGroupedCharts(): void {
    const mockData: any[] = [
      { SaleTargetYear: '2023', SaleTargetAmount: 1500000, TotalActualPrice: 1400000, SaleTargetTeamCode: 'T01', SaleTargetTeamName: 'ทีม A' },
      { SaleTargetYear: '2024', SaleTargetAmount: 1800000, TotalActualPrice: 1700000, SaleTargetTeamCode: 'T01', SaleTargetTeamName: 'ทีม A' },
      { SaleTargetYear: '2025', SaleTargetAmount: 2000000, TotalActualPrice: 1900000, SaleTargetTeamCode: 'T01', SaleTargetTeamName: 'ทีม A' },

      { SaleTargetYear: '2023', SaleTargetAmount: 1200000, TotalActualPrice: 1100000, SaleTargetTeamCode: 'T02', SaleTargetTeamName: 'ทีม B' },
      { SaleTargetYear: '2024', SaleTargetAmount: 1300000, TotalActualPrice: 1250000, SaleTargetTeamCode: 'T02', SaleTargetTeamName: 'ทีม B' },
      { SaleTargetYear: '2025', SaleTargetAmount: 1400000, TotalActualPrice: 1350000, SaleTargetTeamCode: 'T02', SaleTargetTeamName: 'ทีม B' },

      { SaleTargetYear: '2025', SaleTargetAmount: 1600000, TotalActualPrice: 1550000, SaleTargetTeamCode: 'T03', SaleTargetTeamName: 'ทีม C' },
      { SaleTargetYear: '2024', SaleTargetAmount: 1550000, TotalActualPrice: 1500000, SaleTargetTeamCode: 'T03', SaleTargetTeamName: 'ทีม C' },
    ];

    const grouped = new Map<string, any[]>();

    for (const row of mockData) {
      if (!grouped.has(row.SaleTargetTeamCode)) {
        grouped.set(row.SaleTargetTeamCode, []);
      }
      grouped.get(row.SaleTargetTeamCode)!.push(row);
    }

    this.chartPerTeam = [];

    for (const [teamCode, items] of grouped.entries()) {
      const teamName = items[0].SaleTargetTeamName;
      const labels = items.map(i => i.SaleTargetYear);
      const targetValues = items.map(i => i.SaleTargetAmount);
      const actualValues = items.map(i => i.TotalActualPrice);

      this.chartPerTeam.push({
        teamCode,
        teamName,
        labels,
        datasets: [
          {
            label: 'Target',
            data: targetValues,
            backgroundColor: '#42A5F5'
          },
          {
            label: 'Actual',
            data: actualValues,
            backgroundColor: '#66BB6A'
          }
        ]
      });
    }
  }

  generateChartDataPerTeam_OldScenario() {

  //console.log('SaleTeamTargetList before:', this.SaleTeamTargetList);
  //console.log('SaleTeamActualList before:', this.SaleTeamActualList);
  //console.log('SaleTeamList:', this.SaleTeamList);

  /* ---------- สร้าง yearList ตาม noYearBack ---------- */
  const startYear      = parseInt(this.yearSearch ?? new Date().getFullYear().toString());
  const numberOfYears  = this.noYearBack ?? 1;
  const yearList       = Array.from({ length: numberOfYears }, (_, i) => (startYear - i).toString());

  const selectedTeamCode = this.txtSearchSaleTeam;   // null = ดูทุกทีม

  /* ---------- 1) รวมรหัสทีมจาก 3 แหล่ง (Set ป้องกันซ้ำ) ---------- */
  const teamCodes: string[] = selectedTeamCode
    ? [selectedTeamCode]                                         // เลือกทีมเดียว
    : Array.from(new Set([
        ...this.SaleTeamList     .map(t => t.SaleTeamCode),
        ...this.SaleTeamTargetList.map(t => t.SaleTargetTeamCode),
        ...this.SaleTeamActualList.map(a => a.ProjectSaleTeamCode)
      ]));

  /* ---------- 2) เติมปี (mock zero) ให้ Target / Actual ---------- */
  for (const teamCode of teamCodes) {

    /* หา teamName จากหลายแหล่งแบบ fallback */
    const teamName =
        this.SaleTeamTargetList.find(t => t.SaleTargetTeamCode === teamCode)?.SaleTargetTeamName
     ?? this.SaleTeamActualList.find(a => a.ProjectSaleTeamCode === teamCode)?.ProjectSaleTeamName
     ?? this.SaleTeamList      .find(t => t.SaleTeamCode       === teamCode)?.SaleTeamName
     ?? teamCode;

    for (const year of yearList) {

      const hasTarget = this.SaleTeamTargetList
        .some(x => x.SaleTargetTeamCode === teamCode && x.SaleTargetYear === year);

      const hasActual = this.SaleTeamActualList
        .some(x => x.ProjectSaleTeamCode === teamCode && x.ProjectSaleYear === year);

      if (!hasTarget) {
        this.SaleTeamTargetList.push({
          SaleTargetTeamCode:   teamCode,
          SaleTargetTeamName:   teamName,
          SaleTargetYear:       year,
          SaleTargetAmount:     0,
          SaleTargetQuarter:    null,
          SaleTargetMonth:      null,
          SaleTargetFlagNewCust:null,
          SaleTargetEmpCode:    null,
          ProjectSaleTeamName:  null,
          ProjectSaleSubState:  null,
          ProjectSaleTeamCode:  null,
          ProjectSaleYear:      year,
          TotalActualPrice:     null,
          AssetType:            null,
          AssetCategoryCode:    null,
          AssetGroupCode:       null,
          AssetGroupName:       null,
          RequesterEmpCode:     null,
          AssetTypeName:        null,
          AssetCategoryName:    null
        });
      }

      if (!hasActual) {
        this.SaleTeamActualList.push({
          ProjectSaleTeamCode:  teamCode,
          ProjectSaleTeamName:  teamName,
          ProjectSaleYear:      year,
          TotalActualPrice:     0,
          SaleTargetEmpCode:    null,
          SaleTargetTeamName:   null,
          SaleTargetMonth:      null,
          SaleTargetQuarter:    null,
          SaleTargetTeamCode:   null,
          ProjectSaleSubState:  null,
          SaleTargetAmount:     null,
          SaleTargetFlagNewCust:null,
          SaleTargetYear:       year,
          AssetType:            null,
          AssetCategoryCode:    null,
          AssetGroupCode:       null,
          AssetGroupName:       null,
          RequesterEmpCode:     null,
          AssetTypeName:        null,
          AssetCategoryName:    null
        });
      }
    }
  }

  //console.log('SaleTeamTargetList after:', this.SaleTeamTargetList);
  //console.log('SaleTeamActualList after:', this.SaleTeamActualList);

  /* ---------- 3) รวม/สรุปข้อมูลเพื่อทำกราฟ ---------- */
  const allTeamYearCombinations = new Set<string>();
  const teamNames = new Map<string, string>();
  const targetData = new Map<string, number>();
  const actualData = new Map<string, number>();

  /* --- 3.1 Target --- */
  for (const item of this.SaleTeamTargetList) {
    const teamCode = item.SaleTargetTeamCode;
    const year     = item.SaleTargetYear;
    const teamName = item.SaleTargetTeamName;
    let amount     = 0;

    try {
      const raw = item.SaleTargetAmount;
      amount = raw != null ? Number(raw) : 0;
      if (isNaN(amount)) amount = 0;
    } catch { amount = 0; }

    if (!teamCode || !year) continue;
    const key = `${teamCode}_${year}`;
    allTeamYearCombinations.add(key);
    teamNames.set(teamCode, teamName || teamCode);
    targetData.set(key, (targetData.get(key) || 0) + amount);
  }

  /* --- 3.2 Actual --- */
  for (const item of this.SaleTeamActualList) {
    const teamCode = item.ProjectSaleTeamCode;
    const year     = item.ProjectSaleYear;
    const teamName = item.ProjectSaleTeamName;
    let amount     = 0;

    try {
      const raw = item.TotalActualPrice;
      amount = raw != null ? Number(raw) : 0;
      if (isNaN(amount)) amount = 0;
    } catch { amount = 0; }

    if (!teamCode || !year) continue;
    const key = `${teamCode}_${year}`;
    allTeamYearCombinations.add(key);
    teamNames.set(teamCode, teamName || teamCode);
    actualData.set(key, (actualData.get(key) || 0) + amount);
  }

  /* ---------- 4) รวมเป็นโครงสร้าง chart ---------- */
  const teamMap = new Map<string, {
    teamName: string;
    yearlyData: { year: string; target: number; actual: number }[];
  }>();

  allTeamYearCombinations.forEach(key => {
    const [teamCode, year] = key.split('_');
    const target = targetData.get(key) || 0;
    const actual = actualData.get(key) || 0;
    const teamName = teamNames.get(teamCode) || teamCode;

    if (!teamMap.has(teamCode))
      teamMap.set(teamCode, { teamName, yearlyData: [] });

    teamMap.get(teamCode)!.yearlyData.push({ year, target, actual });
  });

  teamMap.forEach(t => t.yearlyData.sort((a, b) => Number(a.year) - Number(b.year)));

  this.chartPerTeam = Array.from(teamMap.entries()).map(([teamCode, t]) => ({
    teamCode,
    teamName: t.teamName,
    labels: t.yearlyData.map(e => e.year),
    datasets: [
      {
        label: 'Target',
        data: t.yearlyData.map(e => e.target),
        backgroundColor(context) {
          const { ctx, chartArea } = context.chart;
          if (!chartArea) return null;
          const g = ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom);
          g.addColorStop(0, '#1A237E');
          g.addColorStop(1, '#64B5F6');
          return g;
        },
        borderColor: 'rgba(63,81,181,1)',
        borderWidth: 2,
        hoverBackgroundColor: 'rgba(22,42,155,0.9)',
        hoverBorderColor: 'rgba(63,81,181,1)',
        hoverBorderWidth: 3,
        borderSkipped: 'bottom' as const,
      },
      {
        label: 'Actual',
        data: t.yearlyData.map(e => e.actual),
        backgroundColor(context) {
          const { ctx, chartArea } = context.chart;
          if (!chartArea) return null;
          const g = ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom);
          g.addColorStop(0, '#1B5E20');
          g.addColorStop(1, '#A5D6A7');
          return g;
        },
        borderColor: 'rgba(0,200,83,0.8)',
        borderWidth: 2,
        hoverBackgroundColor: 'rgba(8,100,46,0.9)',
        hoverBorderColor: 'rgba(0,200,83,1)',
        hoverBorderWidth: 3,
        borderSkipped: 'bottom' as const,
      }
    ] as any[],
  }))
  .filter(chart => {
    if (selectedTeamCode) return chart.teamCode === selectedTeamCode;

    const targetSum = (chart.datasets[0].data as number[]).reduce((s, v) => s + (v || 0), 0);
    const actualSum = (chart.datasets[1].data as number[]).reduce((s, v) => s + (v || 0), 0);
    return targetSum > 0 || actualSum > 0;
  });

  /* ---------- DEBUG ---------- */
  //console.log('===== FINAL RESULT =====');
  this.chartPerTeam.forEach(chart => {
    const targetSum = (chart.datasets[0].data as number[]).reduce((s, v) => s + (v || 0), 0);
    const actualSum = (chart.datasets[1].data as number[]).reduce((s, v) => s + (v || 0), 0);
    //console.log(`${chart.teamCode} (${chart.teamName})`, { years: chart.labels, targetSum, actualSum });
  });
}

  generateChartDataPerTeam02() {
  //console.log('SaleTeamTargetList before:', this.SaleTeamTargetList);
  //console.log('SaleTeamActualList before:', this.SaleTeamActualList);
  //console.log('SaleTeamList:', this.SaleTeamList);

  const startYear = parseInt(this.yearSearch ?? new Date().getFullYear().toString());
  const numberOfYears = this.noYearBack ?? 1;
  const yearList = Array.from({ length: numberOfYears }, (_, i) => (startYear - i).toString()).reverse();

  const selectedTeamCode = this.txtSearchSaleTeam;   // null = ดูทุกทีม

  // 1) รวมรหัสทีม
  const teamCodes: string[] = selectedTeamCode
    ? [selectedTeamCode] 
    : Array.from(new Set([
        ...this.SaleTeamList.map(t => t.SaleTeamCode),
        ...this.SaleTeamTargetList.map(t => t.SaleTargetTeamCode),
        ...this.SaleTeamActualList.map(a => a.ProjectSaleTeamCode)
      ]));

  // 2) เติมปี (mock zero) ให้ Target / Actual
  for (const teamCode of teamCodes) {
    const teamName =
      this.SaleTeamTargetList.find(t => t.SaleTargetTeamCode === teamCode)?.SaleTargetTeamName
      ?? this.SaleTeamActualList.find(a => a.ProjectSaleTeamCode === teamCode)?.ProjectSaleTeamName
      ?? this.SaleTeamList.find(t => t.SaleTeamCode === teamCode)?.SaleTeamName
      ?? teamCode;

    for (const year of yearList) {
      const hasTarget = this.SaleTeamTargetList
        .some(x => x.SaleTargetTeamCode === teamCode && x.SaleTargetYear === year);
      const hasActual = this.SaleTeamActualList
        .some(x => x.ProjectSaleTeamCode === teamCode && x.ProjectSaleYear === year);

      if (!hasTarget) {
        this.SaleTeamTargetList.push({
          SaleTargetTeamCode: teamCode,
          SaleTargetTeamName: teamName,
          SaleTargetYear: year,
          SaleTargetAmount: 0,
          SaleTargetQuarter: null,
          SaleTargetMonth: null,
          SaleTargetFlagNewCust: null,
          SaleTargetEmpCode: null,
          ProjectSaleTeamName: null,
          ProjectSaleSubState: null,
          ProjectSaleTeamCode: null,
          ProjectSaleYear: year,
          TotalActualPrice: null,
          AssetType: null,
          AssetCategoryCode: null,
          AssetGroupCode: null,
          AssetGroupName: null,
          RequesterEmpCode: null,
          AssetTypeName: null,
          AssetCategoryName: null
        });
      }

      if (!hasActual) {
        this.SaleTeamActualList.push({
          ProjectSaleTeamCode: teamCode,
          ProjectSaleTeamName: teamName,
          ProjectSaleYear: year,
          TotalActualPrice: 0,
          SaleTargetEmpCode: null,
          SaleTargetTeamName: null,
          SaleTargetMonth: null,
          SaleTargetQuarter: null,
          SaleTargetTeamCode: null,
          ProjectSaleSubState: null,
          SaleTargetAmount: null,
          SaleTargetFlagNewCust: null,
          SaleTargetYear: year,
          AssetType: null,
          AssetCategoryCode: null,
          AssetGroupCode: null,
          AssetGroupName: null,
          RequesterEmpCode: null,
          AssetTypeName: null,
          AssetCategoryName: null
        });
      }
    }
  }

  //console.log('SaleTeamTargetList after:', this.SaleTeamTargetList);
  //console.log('SaleTeamActualList after:', this.SaleTeamActualList);

  // 3) สร้าง Map เก็บผลรวม
  const yearMap = new Map<string, { target: number, actual: number }>();

  for (const item of this.SaleTeamTargetList) {
    const year = item.SaleTargetYear;
    if (!yearMap.has(year)) yearMap.set(year, { target: 0, actual: 0 });
    yearMap.get(year)!.target += item.SaleTargetAmount ?? 0;
  }

  for (const item of this.SaleTeamActualList) {
    const year = item.ProjectSaleYear;
    if (!yearMap.has(year)) yearMap.set(year, { target: 0, actual: 0 });
    yearMap.get(year)!.actual += item.TotalActualPrice ?? 0;
  }

  // 4) กำหนด chartPerTeam
  if (!selectedTeamCode) {
    // โค้ดที่แก้ไขและเพิ่ม
    const lastYear = yearList[yearList.length - 1];
    this.SaleTargetAllTeamLast = yearMap.get(lastYear)?.target ?? 0;
    console.log('SaleTargetAllTeamLast!!:', this.SaleTargetAllTeamLast);
    // รวมทุกทีมเป็นก้อนเดียว
    this.chartPerTeam = [{
      teamCode: 'ALL',
      teamName: 'รวมทีมทั้งหมด',
      labels: yearList,
      datasets: [
        { label: 'Target', data: yearList.map(y => yearMap.get(y)?.target ?? 0), backgroundColor: '#42A5F5' },
        { label: 'Actual', data: yearList.map(y => yearMap.get(y)?.actual ?? 0), backgroundColor: '#66BB6A' }
      ]
    }];
  } else {
    // มีการเลือกทีมเดียว ใช้ logic เดิม
    const teamMap = new Map<string, { teamName: string, yearlyData: { year: string, target: number, actual: number }[] }>();
    const allTeamYearCombinations = new Set<string>();

    for (const item of this.SaleTeamTargetList) {
      if (item.SaleTargetTeamCode !== selectedTeamCode) continue;
      const key = `${item.SaleTargetTeamCode}_${item.SaleTargetYear}`;
      allTeamYearCombinations.add(key);
    }
    for (const item of this.SaleTeamActualList) {
      if (item.ProjectSaleTeamCode !== selectedTeamCode) continue;
      const key = `${item.ProjectSaleTeamCode}_${item.ProjectSaleYear}`;
      allTeamYearCombinations.add(key);
    }

    const targetData = new Map<string, number>();
    const actualData = new Map<string, number>();
    const teamNames = new Map<string, string>();

    for (const item of this.SaleTeamTargetList) {
      if (item.SaleTargetTeamCode !== selectedTeamCode) continue;
      targetData.set(`${item.SaleTargetTeamCode}_${item.SaleTargetYear}`, item.SaleTargetAmount ?? 0);
      teamNames.set(item.SaleTargetTeamCode, item.SaleTargetTeamName ?? item.SaleTargetTeamCode);
    }
    for (const item of this.SaleTeamActualList) {
      if (item.ProjectSaleTeamCode !== selectedTeamCode) continue;
      actualData.set(`${item.ProjectSaleTeamCode}_${item.ProjectSaleYear}`, item.TotalActualPrice ?? 0);
      teamNames.set(item.ProjectSaleTeamCode, item.ProjectSaleTeamName ?? item.ProjectSaleTeamCode);
    }

    allTeamYearCombinations.forEach(key => {
      const [teamCode, year] = key.split('_');
      if (!teamMap.has(teamCode)) teamMap.set(teamCode, { teamName: teamNames.get(teamCode)!, yearlyData: [] });
      teamMap.get(teamCode)!.yearlyData.push({
        year,
        target: targetData.get(key) ?? 0,
        actual: actualData.get(key) ?? 0
      });
    });

    teamMap.forEach(t => t.yearlyData.sort((a, b) => Number(a.year) - Number(b.year)));

    this.chartPerTeam = Array.from(teamMap.entries()).map(([teamCode, t]) => ({
      teamCode,
      teamName: t.teamName,
      labels: yearList,
      datasets: [
        { label: 'Target', 
          //data: t.yearlyData.map(e => e.target), backgroundColor: '#42A5F5' 
          data: yearList.map(y => t.yearlyData.find(d => d.year === y)?.target ?? 0)
        },
        { label: 'Actual', 
          //data: t.yearlyData.map(e => e.actual), backgroundColor: '#66BB6A' 
          data: yearList.map(y => t.yearlyData.find(d => d.year === y)?.actual ?? 0)
        }
      ]
    }));
  }

  //console.log('===== FINAL RESULT =====');
  //console.log(this.chartPerTeam); //
  }

  generateChartDataPerTeam() {
  const startYear = parseInt(this.yearSearch ?? new Date().getFullYear().toString());
  const numberOfYears = this.noYearBack ?? 1;
  const yearList = Array.from({ length: numberOfYears }, (_, i) => (startYear - i).toString()).reverse();

  const selectedTeamCode = this.txtSearchSaleTeam;

  // 1) รวมรหัสทีม
  const teamCodes: string[] = selectedTeamCode
    ? [selectedTeamCode]
    : Array.from(new Set([
        ...this.SaleTeamList.map(t => t.SaleTeamCode),
        ...this.SaleTeamTargetList.map(t => t.SaleTargetTeamCode),
        ...this.SaleTeamActualList.map(a => a.ProjectSaleTeamCode)
      ]));

  // 2) เติมข้อมูลปี (mock zero) ให้ Target / Actual
  for (const teamCode of teamCodes) {
    const teamName =
      this.SaleTeamTargetList.find(t => t.SaleTargetTeamCode === teamCode)?.SaleTargetTeamName
      ?? this.SaleTeamActualList.find(a => a.ProjectSaleTeamCode === teamCode)?.ProjectSaleTeamName
      ?? this.SaleTeamList.find(t => t.SaleTeamCode === teamCode)?.SaleTeamName
      ?? teamCode;

    for (const year of yearList) {
      const hasTarget = this.SaleTeamTargetList
        .some(x => x.SaleTargetTeamCode === teamCode && x.SaleTargetYear === year);
      const hasActual = this.SaleTeamActualList
        .some(x => x.ProjectSaleTeamCode === teamCode && x.ProjectSaleYear === year);

      if (!hasTarget) {
        this.SaleTeamTargetList.push({
          SaleTargetTeamCode: teamCode,
          SaleTargetTeamName: teamName,
          SaleTargetYear: year,
          SaleTargetAmount: 0,
          SaleTargetQuarter: null,
          SaleTargetMonth: null,
          SaleTargetFlagNewCust: null,
          SaleTargetEmpCode: null,
          ProjectSaleTeamName: null,
          ProjectSaleSubState: null,
          ProjectSaleTeamCode: null,
          ProjectSaleYear: year,
          TotalActualPrice: null,
          AssetType: null,
          AssetCategoryCode: null,
          AssetGroupCode: null,
          AssetGroupName: null,
          RequesterEmpCode: null,
          AssetTypeName: null,
          AssetCategoryName: null
        });
      }

      if (!hasActual) {
        this.SaleTeamActualList.push({
          ProjectSaleTeamCode: teamCode,
          ProjectSaleTeamName: teamName,
          ProjectSaleYear: year,
          TotalActualPrice: 0,
          SaleTargetEmpCode: null,
          SaleTargetTeamName: null,
          SaleTargetMonth: null,
          SaleTargetQuarter: null,
          SaleTargetTeamCode: null,
          ProjectSaleSubState: null,
          SaleTargetAmount: null,
          SaleTargetFlagNewCust: null,
          SaleTargetYear: year,
          AssetType: null,
          AssetCategoryCode: null,
          AssetGroupCode: null,
          AssetGroupName: null,
          RequesterEmpCode: null,
          AssetTypeName: null,
          AssetCategoryName: null
        });
      }
    }
  }

  // 3) รวมข้อมูล Target/Actual รายปี
  const yearMap = new Map<string, { target: number, actual: number }>();
  for (const item of this.SaleTeamTargetList) {
    const year = item.SaleTargetYear;
    if (!yearMap.has(year)) yearMap.set(year, { target: 0, actual: 0 });
    yearMap.get(year)!.target += item.SaleTargetAmount ?? 0;
  }
  for (const item of this.SaleTeamActualList) {
    const year = item.ProjectSaleYear;
    if (!yearMap.has(year)) yearMap.set(year, { target: 0, actual: 0 });
    yearMap.get(year)!.actual += item.TotalActualPrice ?? 0;
  }

  // 4) กำหนด chartPerTeam
  if (!selectedTeamCode) {
    // 🟢 กรณีรวมทุกทีม
    const monthStart = this.ddlMonthStart ? this.MonthList.find(m => m.MonthCode === this.ddlMonthStart)?.MonthName || this.ddlMonthStart : 'Jan';
    const selectedMonthTo = this.ddlMonthEnd ? this.MonthList.find(m => m.MonthCode === this.ddlMonthEnd)?.MonthName : 'Dec';

    const lastYear = yearList[yearList.length - 1];
    this.SaleTargetAllTeamLast = yearMap.get(lastYear)?.target ?? 0;

    // แก้ไข: ใช้ค่าเท่ากันทุกปีแทนการเพิ่มจุดแรก
    const lineData = yearList.map(() => this.SaleTargetAllTeamLast);

    this.chartPerTeam = [{
      teamCode: 'ALL',
      teamName: `Performance as of ${monthStart} ${selectedMonthTo} ${lastYear}`,
      labels: yearList,
      datasets: [
        { label: 'Target', data: yearList.map(y => yearMap.get(y)?.target ?? 0), backgroundColor: '#42A5F5' },
        { label: 'Actual', data: yearList.map(y => yearMap.get(y)?.actual ?? 0), backgroundColor: '#66BB6A' },
        {
          label: `Target Year ${yearList[yearList.length - 1]}`,
          data: lineData,
          type: 'line',
          fill: false,
          borderColor: '#FF0000',
          borderWidth: 2,
          pointRadius: 0,
          xAxisID: 'x-axis-line', // เพิ่ม xAxisID สำหรับ line chart
          borderDash: [5, 5],
          datalabels: {
            formatter: (value, context) => {
    const dataLength = context.dataset.data.length;
    let targetIndex: number;

    // Logic กำหนดตำแหน่ง label
    if (dataLength >= 5) {
      // fix 5 index → label ตรงกลาง index 2
      targetIndex = 2;
    } else if (dataLength === 4) {
      targetIndex = 1; // ตรงกลางแบบคร่าวๆ
    } else if (dataLength === 3) {
      targetIndex = 1; // จุดกลาง
    } else if (dataLength === 2) {
      targetIndex = 0; // label อยู่จุดแรก
    } else {
      targetIndex = 0; // data 1 จุด → label อยู่จุดเดียว
    }

    return context.dataIndex === targetIndex
      ? `Budget @ ${(value / 1000000).toFixed(2)}M`
      : null;
  },
            anchor: 'end',
            align: 'top',
            color: '#FF0000',
            font: { weight: 'bold' }
          }
        }
      ]
    }];
  } else {
    // 🟢 กรณีเลือกทีมเดียว
    const teamMap = new Map<string, { teamName: string, yearlyData: { year: string, target: number, actual: number }[] }>();
    const allTeamYearCombinations = new Set<string>();

    for (const item of this.SaleTeamTargetList) {
      if (item.SaleTargetTeamCode !== selectedTeamCode) continue;
      allTeamYearCombinations.add(`${item.SaleTargetTeamCode}_${item.SaleTargetYear}`);
    }
    for (const item of this.SaleTeamActualList) {
      if (item.ProjectSaleTeamCode !== selectedTeamCode) continue;
      allTeamYearCombinations.add(`${item.ProjectSaleTeamCode}_${item.ProjectSaleYear}`);
    }

    const targetData = new Map<string, number>();
    const actualData = new Map<string, number>();
    const teamNames = new Map<string, string>();

    for (const item of this.SaleTeamTargetList) {
      if (item.SaleTargetTeamCode !== selectedTeamCode) continue;
      targetData.set(`${item.SaleTargetTeamCode}_${item.SaleTargetYear}`, item.SaleTargetAmount ?? 0);
      teamNames.set(item.SaleTargetTeamCode, item.SaleTargetTeamName ?? item.SaleTargetTeamCode);
    }
    for (const item of this.SaleTeamActualList) {
      if (item.ProjectSaleTeamCode !== selectedTeamCode) continue;
      actualData.set(`${item.ProjectSaleTeamCode}_${item.ProjectSaleYear}`, item.TotalActualPrice ?? 0);
      teamNames.set(item.ProjectSaleTeamCode, item.ProjectSaleTeamName ?? item.ProjectSaleTeamCode);
    }

    allTeamYearCombinations.forEach(key => {
      const [teamCode, year] = key.split('_');
      if (!teamMap.has(teamCode)) teamMap.set(teamCode, { teamName: teamNames.get(teamCode)!, yearlyData: [] });
      teamMap.get(teamCode)!.yearlyData.push({
        year,
        target: targetData.get(key) ?? 0,
        actual: actualData.get(key) ?? 0
      });
    });

    teamMap.forEach(t => t.yearlyData.sort((a, b) => Number(a.year) - Number(b.year)));

    this.chartPerTeam = Array.from(teamMap.entries()).map(([teamCode, t]) => {
      const lastYear = yearList[yearList.length - 1];
      const monthStart = this.ddlMonthStart ? this.MonthList.find(m => m.MonthCode === this.ddlMonthStart)?.MonthName || this.ddlMonthStart : 'Jan';
      const monthTo = this.ddlMonthEnd ? this.MonthList.find(m => m.MonthCode === this.ddlMonthEnd)?.MonthName || this.ddlMonthEnd : 'Dec';
      const lastTarget = t.yearlyData.find(d => d.year === lastYear)?.target ?? 0;
      
      // แก้ไข: ใช้ค่าเท่ากันทุกปีแทนการเพิ่มจุดแรก
      const lineData = yearList.map(() => lastTarget);

      return {
        teamCode,
        teamName: `Performance as of ${monthStart} - ${monthTo} ${lastYear} (${t.teamName})`,
        labels: yearList,
        datasets: [
          {
            label: 'Target',
            data: yearList.map(y => t.yearlyData.find(d => d.year === y)?.target ?? 0),
            backgroundColor: '#42A5F5'
          },
          {
            label: 'Actual',
            data: yearList.map(y => t.yearlyData.find(d => d.year === y)?.actual ?? 0),
            backgroundColor: '#66BB6A'
          },
          {
            label: `Target Year ${yearList[yearList.length - 1]}`,
            data: lineData,
            type: 'line',
            fill: false,
            borderColor: '#FF0000',
            borderWidth: 2,
            pointRadius: 0,
            xAxisID: 'x-axis-line', // เพิ่ม xAxisID สำหรับ line chart
            borderDash: [5, 5],
            datalabels: {
              formatter: (value, context) => {
    const dataLength = context.dataset.data.length;
    let targetIndex: number;

    // Logic กำหนดตำแหน่ง label
    if (dataLength >= 5) {
      // fix 5 index → label ตรงกลาง index 2
      targetIndex = 2;
    } else if (dataLength === 4) {
      targetIndex = 1; // ตรงกลางแบบคร่าวๆ
    } else if (dataLength === 3) {
      targetIndex = 1; // จุดกลาง
    } else if (dataLength === 2) {
      targetIndex = 0; // label อยู่จุดแรก
    } else {
      targetIndex = 0; // data 1 จุด → label อยู่จุดเดียว
    }

    return context.dataIndex === targetIndex
      ? `Budget @ ${(value / 1000000).toFixed(2)}M`
      : null;
  },
              anchor: 'end',
              align: 'top',
              color: '#FF0000',
              font: { weight: 'bold' }
            }
          }
        ]
      };
    });
  }
}

  onddlMonthStartChange(event: Event): void {
  const selectElement = event.target as HTMLSelectElement;
  this.ddlMonthStart = selectElement.value || null;

    if (this.ddlMonthStart === null || this.ddlMonthStart === 'null') {
    this.ddlMonthEnd = null;
  }

  this.validateMonthRange();
}

  onddlMonthEndChange(event: Event): void {
   const selectElement = event.target as HTMLSelectElement;
   this.ddlMonthEnd = selectElement.value || null;

   if (this.ddlMonthEnd === null || this.ddlMonthEnd === 'null') {
    this.ddlMonthStart = null;
  }

   this.validateMonthRange();
  }

  validateMonthRange(): void {
    this.monthErrorMessage = '';

    this.isMonthEndValid = true;
  }

  async btnSearch_OnClick() {
    this.isMonthEndValid = true;
    this.monthErrorMessage = '';

  if (!this.yearSearch) {
    this.isMonthEndValid = false;
    this.monthErrorMessage = 'กรุณาเลือกปี';
    return;
  }

  // Helper function check null (include string "null")
  const isEmpty = (value: any) => {
    return value === null || 
           value === undefined || 
           value === '' || 
           value === 'null' ||  // Add this
           value === '0';
    };

    const isMonthStartEmpty = isEmpty(this.ddlMonthStart);
    const isMonthEndEmpty = isEmpty(this.ddlMonthEnd);

    // must select both or not select both
    if (isMonthStartEmpty !== isMonthEndEmpty) {
        this.isMonthEndValid = false;
        this.monthErrorMessage = 'กรุณาเลือก Month From และ Month To ให้ครบ';
        return;
    }

    // select both and check interval
    if (!isMonthStartEmpty && !isMonthEndEmpty) {
        const start = parseInt(this.ddlMonthStart.toString(), 10);
        const end = parseInt(this.ddlMonthEnd.toString(), 10);

        if (isNaN(start) || isNaN(end)) {
            this.isMonthEndValid = false;
            this.monthErrorMessage = 'ค่าเดือนไม่ถูกต้อง';
            return;
        }

        if (end < start) {
            this.isMonthEndValid = false;
            this.monthErrorMessage = 'Month To ต้องมากกว่าหรือเท่ากับ Month From';
            return;
      }
  }

    //console.log('Year:', this.yearSearch);
    //console.log('Month From Pass:', this.ddlMonthStart);
    //console.log('Month To Pass:', this.ddlMonthEnd);
    //console.log('ผ่านการตรวจสอบ');
    await this.loadTeamTarget();
    await this.loadTeamActual();
    this.generateChartDataPerTeam()
  }

  async btnclear_OnClick() {
    this.ddlMonthStart = null;
    this.ddlMonthEnd = null;
    this.noYearBack = 5;
    this.txtSearchSaleTeam = null;
    await this.initializeComponent();
    await this.loadTeamTarget();
    await this.loadTeamActual();
    this.generateChartDataPerTeam();
  }
  
}

